import React from 'react';

export class RelationshipGroupListExcel extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			loading: true,
			isPreload: false,
			relationship_group: false,
			relationship_group_list: [],
		};
	}

	// route() {
	// 	window.Route.on({
	// 		'/v2/relationship-duplicate': () => {
	// 			this.fetch();
	// 		}
	// 	}).match();
	// }

	componentDidMount() {
		this.fetchGroup();
	}

	// componentDidUpdate(prevProps) {
	// 	if (this.props.location.pathname !== prevProps.location.pathname) {
	// 		this.route();
	// 	}
	// }

	fetchGroup() {
		// let data = window.Global.getAllQueryStrings();
		window.Global.ajax({
			method: 'GET',
			url: process.env.REACT_APP_DOMAIN + '/api/relationship/group',
			data: {
				relationship_group_id: this.props.match.params.relationship_group_id,
			},
			done: (response) => {
				this.setState({
					loading: false,
					relationship_group: response.relationship_group.length
						? response.relationship_group[0]
						: false,
					// selected_relationship: response.selected_relationship,
				}, () => {

				})
			},
			fail: () => {

			}
		});
	}

	render() {
		if (this.state.loading) {
			return null;
		}

		return (
			<div>
				<div className="ui huge breadcrumb">
					<a className="active section" href="/relationship/group" data-no_navigo={""}>กลุ่มลูกค้า</a>
					<span className="divider big-margin">/</span>
					<a className="section"
					   data-no_navigo={""}
					   href={"/relationship/group/" + this.props.match.params.relationship_group_id}>
						{this.state.relationship_group.name}
					</a>
					<span className="divider big-margin">/</span>
					<a className="active section"
					   href={window.location.href}
					   data-no_navigo={""}>
						เข้ารายชื่อคู่ค้า
					</a>
				</div>
				<form className="ui form ui tall stacked padded segment"
				      autoComplete={'off'}
					// key={'d' + window.Global.getRandomInt(1, 10000000)}
					   ref={(ref) => {
						   window.$(ref).form2('setup');
						   window.$(ref).form2('submit', {
							   method: 'POST',
							   url: process.env.REACT_APP_DOMAIN + '/api/relationship/group/list/import-by-google-sheet',
							   beforeSent: (object) => {
								   if (!window.confirm('ยืนยันหรือไม่?')) {
									   return false;
								   }

								   object.relationship_group_id = this.props.match.params.relationship_group_id;

								   if (this.state.isPreload) {
									   object.is_confirm = true;
								   }
								   return object;
							   },
							   loadingButton: window.$(ref).find('.button.approve'),
							   submitButton: window.$(ref).find('.button.approve'),
							   onSuccess: (response) => {
								   if (!response.success) {
									   return;
								   }
								   if (response.is_confirm === 0) {
									   this.setState({
										   ...this.state,
										   isPreload: true,
										   relationship_group_list: response.relationship_group_list,
									   })
								   } else {
									   this.setState({
										   ...this.state,
										   isSuccess: true,
										   // document: _.clone(response.document)
									   })

									   window.Global.messageTop({
										   type: 'positive',
										   message: 'บันทึกข้อมูลเรียบร้อย'
									   });
								   }
							   }
						   });
					   }}>
					<h2 className="ui huge breadcrumb">
					<span
						className="active section">ระบบนำเข้ารายชื่อคู่ค้า ไปยังกลุ่มคู่ค้า: {this.state.relationship_group.name}</span>
						{/*<span className="divider">/</span>*/}
						{/*<a className="section" href="/v2/relationships?id=36355">นิติ 1</a>*/}
					</h2>
					<h4 className="ui dividing header">รายละเอียด</h4>
					<div className="flex row wrap three column computer padded">
						<div className="column field required">
							<label htmlFor="">Google Sheet ID</label>
							<input type="text" name={'google_sheet_id'} placeholder={'Google Sheet ID'}/>
						</div>
						<div className="column field required">
							<label htmlFor="">Google Sheet Name</label>
							<input type="text" name={'google_sheet_name'} placeholder={'Google Sheet Name'}
							       defaultValue={'รายชื่อคู่ค้า'}/>
						</div>
						{/*<div className="column field">*/}
						{/*	<label htmlFor="">วันที่เอกสารยกมา</label>*/}
						{/*	<div data-form_calendar="date"*/}
						{/*	     data-input_name="doc_date"*/}
						{/*	     data-placeholder="วันที่"*/}
						{/*	     data-initialdate={''}*/}
						{/*	     data-locale="th"*/}
						{/*	/>*/}
						{/*</div>*/}
					</div>
					<h4 className="ui dividing header">สรุปรายชื่อคู่ค้าที่จะนำเข้าไปยังกลุ่มคู่ค้า
						: {this.state.relationship_group.name}</h4>
					<div className="Table_root ui basic table theme1">
						<div className="thead">
							<div className="tr">
								<div className="th span2">ลำดับ</div>
								<div className="th span6">ทะเบียนคู่ค้า</div>
								<div className="th span2">Username</div>
								<div className="th span2"></div>
								<div className="th span2"></div>
							</div>
						</div>
						<div className="tbody">
							<div>
								{
									this.state.isPreload
										?
										this.state.relationship_group_list.map((relationship_group_list, i) => {
											return (
												<div key={i}
												     className={'tr flex row wrap'}>
													<div className="th span2">{i + 1}</div>
													<div className="th span6">
														<a href={"/relationships?id=" + relationship_group_list.relationship.id}
														   className={'link'}
														   rel={'noopener noreferrer'}
														   target={'_blank'}
														   data-no_navigo={""}>
															{relationship_group_list.relationship.name} ({relationship_group_list.relationship.id})
														</a>
													</div>
													<div
														className="th span2">{relationship_group_list.relationship_account.username}</div>
													<div className="th span2"></div>
													<div className="th span2"></div>
												</div>
											)
										})
										: null
								}
								{
									!this.state.isPreload
									&&
									<div className={'tr flex row wrap'}>
										<div className="th span16" style={{textAlign: 'center'}}>รอดึงข้อมูล</div>
									</div>
								}
								{
									this.state.isPreload
									&& this.state.relationship_group_list.length === 0
									&&
									<div className={'tr flex row wrap'}>
										<div className="th span16" style={{textAlign: 'center'}}>ไม่มีรายชื่อคู่ค้าที่จะนำเข้า
										</div>
									</div>
								}
							</div>
						</div>
					</div>
					<div style={{margin: '2rem 0 0 0'}}>
						<div className="ui error message"/>
						{
							!this.state.isSuccess
							&&
							<div className={'flex row wrap'}>
								<a href={"/relationship/group/" + this.props.match.params.relationship_group_id}
								   data-no_navigo={""}
								>
									<button type="button"
									        className="ui button">
										ยกเลิก
									</button>
								</a>
								<div className={'right floated'}>
									{
										this.state.isPreload
										&&
										<button type="button"
										        onClick={() => {
											        this.setState({
												        ...this.state,
												        isPreload: false,
												        relationship_group_list: [],
											        })
										        }}
										        className="ui button">
											เริ่มต้นใหม่
										</button>
									}
									<button type="button"
									        className="ui button green approve">
										{
											!this.state.isPreload
											&&
											<span>ดึงข้อมูล</span>
										}
										{
											this.state.isPreload
											&&
											<span>ยืนยันนำเข้าคู่ค้าทั้งหมด {this.state.relationship_group_list.length.format()} รายชื่อ</span>
										}
									</button>
								</div>
							</div>
						}
						{
							this.state.isSuccess
							&&
							<div className={'flex row wrap'}>
								<div className={'right floated'}>
									<div style={{color: 'green'}}>บันทึกข้อมูลเรียบร้อย</div>
								</div>
							</div>
						}
					</div>
				</form>
			</div>
		)
	}
}
